<template>
  <div class="main-content">
    <div class="card" v-if="!hideSelect">
      <div class="card-header bg-info">
        <h5>Выбор препарата</h5>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-8">
            <label for="">Препарат</label>
            <div class="flex align-items-center">
              <i v-if="selectedDrug && selectedDrug.id" @click="openDrugEdit(selectedDrug.id)"
                 class="icon-fa icon-fa-edit openEditDrugIcon"/>
              <div class="flex-grow-1">
                <DrugSearchNew
                  :onSelect="selectDrug"
                  :searchOptions="{'details':true}"
                />
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <label for="">Проект</label>
            <select @change="loadDrugData" v-model="selectedProject" class="form-control">
              <option v-for="project in activeProjectsToEdit" :value="project.id">
                {{ project.title }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>

    <template v-if="drugData">
      <div class="card" v-if="drugSiteData">
        <div class="card-body">
          <p>Данные на сайте: <a :href="drugSiteData.link" target="_blank">{{ drugSiteData.title }}</a>
            ({{ selectedDrug && selectedDrug.id }})
            <span
              v-bind:class="{'badge': true, 'badge-success': drugActiveOnProject, 'badge-warning': !drugActiveOnProject}">{{
                drugActiveOnProject ? 'Активен' : 'Не активен'
              }}</span>
          </p>
        </div>
      </div>
      <SiteDrugEditBlock
        :allData="allData"
        :drug="drugData"
        :selectedAnalogDrugs="analogDrugs"
        :selectedAnalogTableDrugs="analogTableDrugs"
        :selectedOtherForms="otherForms"
        :reloadDrug="loadDrugData"
        :siteId="selectedProject"
        :siteSelects="{...(siteData || {}), ...drugSiteData}"
        :drugDetails="drugData?.site_details ?? []"
        :details="siteDetails"
      />
    </template>

  </div>
</template>

<script>

import api from '@/api'
import DrugSearchNew from "@/components/drugs/DrugSearchNew";
import Editor from '@tinymce/tinymce-vue'
import LoadingButton from "@/components/buttons/LoadingButton";
import SiteDrugEditBlock from "@/views/drugs/componetns/SiteDrugEditBlock";
import store from "@/store";

export default {
  props: ['hideSelect', 'loadDrug'],
  components: {
    DrugSearchNew,
    Editor,
    LoadingButton,
    SiteDrugEditBlock,
  },
  data() {
    return {
      allData: {},
      drugActiveOnProject: false,
      analogDrugs: [],
      analogTableDrugs: [],
      otherForms: [],
      drugSiteData: null,
      loadingBtn: false,
      editAllow: {
        slug: false,
      },
      siteDetails: {},
      siteData: {},
      tag: '',
      activeProjectsToEdit: [],
      loading: false,
      selectedDrug: null,
      selectedProject: 1,
      drugData: null,
    }
  },
  computed: {
    $AllProjects() {
      return this.$store.getters['platform/projects'].filter((p) => p.is_active)
    },
  },
  mounted() {
    this.activeProjectsToEdit = this.$AllProjects.reduce((acc, p) => {
      if (p.url && ![4, 13].includes(p.id)) {
        acc.push(p);
      }
      return acc;
    }, []);
    if (this.$route.params && this.$route.params.projectId) {
      this.selectedProject = +this.$route.params.projectId;
    }
    if (this.$route.params && this.$route.params.id) {
      this.selectedDrug = {id: this.$route.params.id};
      this.loadDrugData();
      return;
    }
    if (this.loadDrug) {
      this.selectedDrug = {id: this.loadDrug.drugId};
      this.selectedProject = this.loadDrug.projectId;
      this.loadDrugData();
    }
  },
  methods: {
    openDrugEdit(drugId) {
      store.dispatch('modals/setSideData', {drugId: drugId, type: 'editDrug'})
    },
    async updateDrug() {
      this.loadingBtn = true;
      const {data} = await api.post('/new/drugs/siteEdit', {
        action: 'updateDrug',
        drug_id: this.selectedDrug.id,
        site_id: this.selectedProject,
        drugData: this.drugData
      })
      if (data.errors && data.errors.length) {
        data.errors.forEach((e) => {
          console.log(e);
          toastr['warning'](e.project ? e.project + ' ' + (e.message || e.error || 'Ошибка') : 'Ошибка');
        })
        return;
      }
      this.loadingBtn = false;
    },
    async loadDrugData() {
      if (!this.selectedDrug || !this.selectedDrug.id || !this.selectedProject) return;
      this.loading = true;
      this.drugData = null;
      const {data} = await api.post('/new/drugs/siteEdit', {
        action: 'getInfo',
        drug_id: this.selectedDrug.id,
        site_id: this.selectedProject
      })
      if (!data.success) {
        toastr['warning'](data.message || 'Ошибка');
      } else {
        this.allData = {
          videos: data.videos,
        };

        this.analogDrugs = data.analogDrugs || [];
        this.analogTableDrugs = data.analogTableDrugs || [];
        this.otherForms = data.otherForms || [];

        const activePrice = data.drug.prices.find((p) => +p.qty === 1);
        this.drugActiveOnProject = activePrice && activePrice.is_active || false;
        this.drugSiteData = data.drugSiteData;
        this.siteData = data.siteData;
        this.siteDetails = data.siteDetails;
        this.drugData = data.drug;
      }
      this.loading = false;
    },
    selectDrug(drug) {
      this.selectedDrug = drug;
      this.loadDrugData();
    }
  }
}
</script>

<style scoped>
.card {
  margin-bottom: 5px;
}

h4 {
  margin-top: 5px;
}

p {
  margin-bottom: 3px;
}

.openEditDrugIcon {
  color: white;
  background-color: #5bbfde;
  padding: 3px 4px;
  cursor: pointer;
  font-weight: 700;
  border-radius: 4px;
  text-align: center;
  margin-right: 5px;
  height: 20px
}

.analog_drug_selector span {
  margin-right: 5px;
  margin-bottom: 5px;
  background-color: #def2f8;
  padding: 3px 15px;
}
</style>
